import React, { useEffect, useState } from "react";
import {
  RingProgress,
  Text,
  Group,
  Grid,
  Table,
  Loader,
  Center,
} from "@mantine/core";
import { url } from "../../settings/linkUrl";
import chrome from "../AdminPageChrome.module.css";

interface dataProgress {
  label: string;
  stats: string;
  progress: number;
  color: string;
}

export default function AdministratorHomePage() {
  const [dataProgress, setDataProgress] = useState<dataProgress[]>([]);
  const [dataMoney, setDataMoney] = useState<any[]>([]);
  const [loadingChart, setLoadingChart] = useState(true);
  const [loadingMoney, setLoadingMoney] = useState(true);
  const [errorMoney, setErrorMoney] = useState("");

  const LoadPage = () => {
    setLoadingChart(true);
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}listname/countchart`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        setDataProgress(Array.isArray(json) ? json : []);
      })
      .catch(() => {
        setDataProgress([]);
      })
      .finally(() => setLoadingChart(false));
  };

  const LoadMoney = () => {
    setLoadingMoney(true);
    setErrorMoney("");
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}listname/countmoney`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        if (Array.isArray(json)) {
          setDataMoney(json);
        } else {
          setDataMoney([]);
          setErrorMoney(json?.message || "โหลดยอดเงินไม่สำเร็จ");
        }
      })
      .catch((error) => {
        setDataMoney([]);
        setErrorMoney(error.message || "โหลดยอดเงินไม่สำเร็จ");
      })
      .finally(() => setLoadingMoney(false));
  };

  useEffect(() => {
    LoadPage();
    LoadMoney();
  }, []);

  const stats = dataProgress.map((stat) => {
    return (
      <Grid.Col span={{ base: 12, sm: 6, md: 4 }} key={stat.label}>
        <div className="admin-stat-panel">
          <Group wrap="nowrap" align="center">
            <RingProgress
              size={110}
              thickness={12}
              roundCaps
              sections={[{ value: Number(stat.progress) || 0, color: stat.color }]}
              label={
                <Text size="lg" ta="center" c={stat.color} fw={700}>
                  {stat.progress}%
                </Text>
              }
            />
            <div>
              <Text c="dimmed" size="xs" tt="uppercase" fw={600}>
                {stat.label}
              </Text>
              <Text fw={700} size="xl" c="var(--admin-navy)">
                {stat.stats}
              </Text>
            </div>
          </Group>
        </div>
      </Grid.Col>
    );
  });

  const rows = dataMoney.map((element: any, index) => (
    <Table.Tr key={`${element.name_detail}-${index}`}>
      <Table.Td style={{ textAlign: "center" }}>{index + 1}</Table.Td>
      <Table.Td>{element.name_detail}</Table.Td>
      <Table.Td style={{ textAlign: "center" }}>{element.register}</Table.Td>
      <Table.Td style={{ textAlign: "right", fontWeight: 600 }}>
        {element.money}
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <header className={chrome.pageHeader}>
        <h1 className={chrome.title}>ภาพรวมการลงทะเบียน</h1>
        <p className={chrome.subtitle}>
          สรุปสถิติและยอดเงินจากการลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร
        </p>
      </header>

      {loadingChart && dataProgress.length === 0 ? (
        <Center py="xl">
          <Loader color="blue" />
        </Center>
      ) : (
        <Grid>{stats}</Grid>
      )}

      <div className="admin-panel" style={{ marginTop: "1.1rem" }}>
        <Group justify="space-between" mb="sm">
          <Text fw={600} c="var(--admin-navy)">
            สรุปยอดเงินตามรายการ
          </Text>
          {loadingMoney ? (
            <Group gap="xs">
              <Loader size="sm" color="blue" />
              <Text size="sm" c="dimmed">
                กำลังโหลดยอดเงิน...
              </Text>
            </Group>
          ) : null}
        </Group>
        <div className="admin-table-wrap">
          <Table highlightOnHover withRowBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th style={{ textAlign: "center", width: 56 }}>#</Table.Th>
                <Table.Th>รายการ</Table.Th>
                <Table.Th style={{ textAlign: "center" }}>จำนวน</Table.Th>
                <Table.Th style={{ textAlign: "right" }}>ยอดเงิน</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows.length > 0 ? (
                rows
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={4}>
                    <div className="admin-empty">
                      {loadingMoney
                        ? "กำลังดึงข้อมูลจากระบบการเงิน กรุณารอสักครู่..."
                        : errorMoney
                          ? `เกิดข้อผิดพลาด: ${errorMoney}`
                          : "ยังไม่มีข้อมูลยอดเงิน"}
                    </div>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </div>
      </div>
    </>
  );
}
